module.exports = __webpack_public_path__ + "img/labmemtest_btn_download_tc.128d74b5.png";